import React, { useState } from 'react';
import Headshot from '../../Resources/Images/Headshot.jpg'
import HeadshotEE from '../../Resources/Images/Headshot-Egg.jpg'
import '../../CSS/LandingPage.css';

function LandingImage() {

    const [hover, setHover] = useState(false)

    return (
        <div 
            className="Landing-image-effect" 
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}>
                { hover ? 
                    <img id="Headshot-alt" src={HeadshotEE} alt="Headshot-Easter-Egg" />
                :
                    <img id="Headshot-normal" src={Headshot} alt="Headshot" />   
                }
        </div>
    )
}

export default LandingImage;
